/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WYSIWYGViewerWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionInfo_organization$ref: FragmentReference;
declare export opaque type TensionInfo_organization$fragmentType: TensionInfo_organization$ref;
export type TensionInfo_organization = {|
  +$fragmentRefs: WYSIWYGViewerWithFeatureFlag_organization$ref,
  +$refType: TensionInfo_organization$ref,
|};
export type TensionInfo_organization$data = TensionInfo_organization;
export type TensionInfo_organization$key = {
  +$data?: TensionInfo_organization$data,
  +$fragmentRefs: TensionInfo_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionInfo_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGViewerWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'f6a7996e756bbd6894e215c4fd01a042';

module.exports = node;
